import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';
import { getMessaging } from "firebase/messaging";

const firebaseApp = initializeApp({
    apiKey: "AIzaSyAZd-o2TL85fErURW-nQzuP0URNNo43JNA",
    authDomain: "legal-by-sofu.firebaseapp.com",
    projectId: "legal-by-sofu",
    storageBucket: "legal-by-sofu.appspot.com",
    messagingSenderId: "283248080483",
    appId: "1:283248080483:web:260d46d081f6343b072a56",
    measurementId: "G-V0SXHZNBKK",
});

getAnalytics();

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp);
const messaging = getMessaging(firebaseApp);

export {
    firebaseApp,
    auth,
    db,
    storage,
    functions,
    messaging
};